export default __webpack_public_path__ + "static/media/icon-bottom-nav-visits.6bcfb36f.svg";